import { useEffect, useRef, useState } from "react"

import classes from './CopyText.module.css'

const DEFAULT_MESSAGE = 'Click to copy to clipboard'
const COPIED_FEEDBACK_MS = 600

export default function CopyTextInhanced({text, maxWidth, reversed, isLink}){
    const identifierRef = useRef(null)
    const copiedFeedbackRef = useRef(false)
    const resetTimerRef = useRef(null)

    const [messageText, setMessageText] = useState(DEFAULT_MESSAGE)
    const [showTooltip, setShowTooltip] = useState(false)

    useEffect(() => {
        return () => {
            if (resetTimerRef.current) {
                clearTimeout(resetTimerRef.current)
            }
        }
    }, [])

    const pointerEnterHandler = () => {
        if (copiedFeedbackRef.current) {
            return
        }
        setMessageText(DEFAULT_MESSAGE)
        setShowTooltip(true)
    }

    const pointerLeaveHandler = () => {
        if (copiedFeedbackRef.current) {
            return
        }
        setShowTooltip(false)
    }

    const copyTexthandler = () => {
        navigator.clipboard.writeText(identifierRef.current.innerText)
        copiedFeedbackRef.current = true
        setMessageText('Copied')
        setShowTooltip(true)

        if (resetTimerRef.current) {
            clearTimeout(resetTimerRef.current)
        }

        resetTimerRef.current = setTimeout(() => {
            copiedFeedbackRef.current = false
            setShowTooltip(false)
            setMessageText(DEFAULT_MESSAGE)
        }, COPIED_FEEDBACK_MS)
    }

    return <div className={`${classes.identifier} ${reversed ? classes.reversed : ''} `}>
        <span className={`${maxWidth ? classes.truncated : ''}`} ref={identifierRef} style={{whiteSpace: 'nowrap'}}>
            {!isLink && text}
            {isLink && <a href={text} target="_blank" rel="noreferrer">{text}</a>}
        </span>

        <button
            type="button"
            onClick={copyTexthandler}
            onPointerEnter={pointerEnterHandler}
            onPointerLeave={pointerLeaveHandler}
            className={classes.copy_button}
        >
            <i className="ti ti-copy"></i>
            {showTooltip && (
                <span className={classes.message_right}>{messageText}</span>
            )}
        </button>
    </div>
}
